import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { ClaimType } from '~/utils/constants';
import { checkIfPastReturnWindow } from '~/utils/order';
import { makeCrewAction, makeCrewLoader, redirect } from '~/utils/routing';

export const { loader, useLoaderData: useNewRequestLoaderData } =
  makeCrewLoader(({ context: { order, settings } }, appState) => {
    if (order.allowClaimTypeSelection) {
      return order.allowClaimTypeSelection.params;
    }

    const canWarranty =
      settings.warranty.isEnabled &&
      order.lineItems.every(checkIfPastReturnWindow(settings.return.isEnabled));

    const claimType = canWarranty ? ClaimType.warranty : ClaimType.return;

    appState.dispatch(appState.actions.crewClaim.setClaimType(claimType));

    return redirect(`../${claimType}`);
  });

export const { action, useActionResult: useNewRequestActionResult } =
  makeCrewAction(({ formData }, appState) => {
    const result = zfd
      .formData({
        claimType: zfd.text(z.nativeEnum(ClaimType)),
      })
      .parse(formData);

    appState.dispatch(
      appState.actions.crewClaim.setClaimType(result.claimType),
    );

    return redirect(`../${result.claimType}`);
  });
